import { useTranslation } from 'react-i18next';

import Typography from '../../../../../../components/Typography';
import { i18nNS } from '../../../../../../i18n';
import { format } from '../../../../../../utils/datetime';
import usePollIdentifier from './vm';

const PollIdentifier = () => {
  const { t } = useTranslation([i18nNS.POLL]);

  const { course, cls } = usePollIdentifier();

  if (!course) return;
  if (!cls) return;

  return (
    <Typography variant="textXsBold" color="grey.500" lineHeight="unset">
      {t('course_code_colon_poll_for_lecture_scheduled_at_time_on_date', {
        ns: i18nNS.POLL,
        courseCode: course.code,
        classDateTime: format(cls.startTime, "hh:mm a 'on' do MMM, yyyy"),
      })}
    </Typography>
  );
};

export default PollIdentifier;
